// BaseMapDataOverlaysTab.vue
<template>
  <div>
    <!-- ───────────────────────── DATA OVERLAYS ───────────────────────── -->
    <div class="row">
      <div class="col-12 px-0 pt-3 py-2">
        <p class="px-3 mb-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.data_overlays') }}</strong></small></p>
        <div ref="overlayScroll" class="mapstyle-list">

          <div class="position-relative d-inline-block" @click="toggleHeatmapOverlay">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': heatmapActive }">
              <img src="../../../images/map_style/heatmap_overlay_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.heatmap_2')" draggable="false" />
              <!-- Free users get the overlay but capped at z12; PRO+ unlocks native z15 trail detail. -->
              <img v-if="!heatmapIsPro" :src="proBadge" class="mapstyle-pro-badge" :alt="$t('base_map_dialog.base_map_data_overlays_tab.trail_detail_is_a_pro_feature')" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.heatmap') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleSlopeOverlay">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': slopeAngleActive }">
              <img src="../../../images/map_style/slope_overlay_style.jpg" :alt="$t('shared.map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.slope_angle') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleCellCoverageOverlay">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': cellCoverageActive }">
              <img src="../../../images/map_style/cell_overlay_style.jpg" :alt="$t('shared.map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.cell_coverage') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleOfficialHikesOverlay">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': officialHikesActive }">
              <img src="../../../images/map_style/trails_overlay_style.jpg" :alt="$t('shared.map')" draggable="false" />
              <button
                type="button"
                class="mapstyle-line-style-btn"
                :title="$t('base_map_dialog.base_map_data_overlays_tab.customise_line_style')"
                :aria-label="$t('base_map_dialog.base_map_data_overlays_tab.customise_hiiker_hikes_line_style')"
                @click.stop="$emit('customise-overlay-line', 'officialHikes')"
              >
                <span class="material-icons">settings</span>
              </button>
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.hiiker_hikes') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleLandAccessOverlay">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': landAccessActive }">
              <img src="../../../images/map_style/public_overlay_style.jpg" :alt="$t('shared.map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.public_access') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleCyclingRoutesOverlay">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': cyclingRoutesActive }">
              <img src="../../../images/map_style/cycling_overlay_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.cycling_routes_2')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.cycling_routes') }}</strong></small></p></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ───────────────────────── WEATHER MAPS ───────────────────────── -->
    <div class="row">
      <div class="col-12 px-0 py-1">
        <p class="px-3 mb-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.weather_maps') }}</strong></small></p>
        <div ref="weatherScroll" class="mapstyle-list">

          <div class="position-relative d-inline-block" @click="toggleWeatherOverlay({type:'TA2',name:'temperature'})">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': activeWeatherLayer.name === 'temperature' }">
              <img src="../../../images/map_style/temperature_weather_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.temperature_map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.temperature') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleWeatherOverlay({type:'CL',name:'cloud'})">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': activeWeatherLayer.name === 'cloud' }">
              <img src="../../../images/map_style/cloud_weather_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.cloud_map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.cloud') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleWeatherOverlay({type:'PAR0',name:'rainfall'})">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': activeWeatherLayer.name === 'rainfall' }">
              <img src="../../../images/map_style/rainfall_weather_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.rainfall_map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.rainfall') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleWeatherOverlay({type:'PAS0',name:'snowfall'})">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': activeWeatherLayer.name === 'snowfall' }">
              <img src="../../../images/map_style/snowfall_weather_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.snowfall_map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.snowfall') }}</strong></small></p></div>
            </div>
          </div>

          <div class="position-relative d-inline-block" @click="toggleWeatherOverlay({type:'WND',name:'wind'})">
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': activeWeatherLayer.name === 'wind' }">
              <img src="../../../images/map_style/wind_weather_style.jpg" :alt="$t('base_map_dialog.base_map_data_overlays_tab.wind_map')" draggable="false" />
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.wind') }}</strong></small></p></div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ───────────────────────── MY TRAILS ───────────────────────── -->
    <div class="row">
      <div class="col-12 px-0 py-1">
        <p class="px-3 mb-0"><small><strong>{{ $t('base_map_dialog.base_map_data_overlays_tab.my_trails') }}</strong></small></p>
        <div ref="trailsScroll" class="mapstyle-list">

          <div
            v-for="(label, source) in trailOptions"
            :key="source"
            class="position-relative d-inline-block"
            @click="toggleTrail(source)"
          >
            <div class="mapstyle-card" :class="{ 'mapstyle-card-active': isSourceActive(source) }">
              <img :src="getTrailImage(source)" :alt="$t('shared.map')" draggable="false" />
              <button
                v-if="overlayLineTypeForSource(source)"
                type="button"
                class="mapstyle-line-style-btn"
                :title="$t('base_map_dialog.base_map_data_overlays_tab.customise_line_style_2')"
                :aria-label="$t('base_map_dialog.base_map_data_overlays_tab.customise_named_line_style', { label })"
                @click.stop="$emit('customise-overlay-line', overlayLineTypeForSource(source))"
              >
                <span class="material-icons">settings</span>
              </button>
              <div class="hiking-text p-1"><p class="m-0"><small><strong>{{ label }}</strong></small></p></div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

// Images that are strictly presentation-layer resources stay here
import plannedImage     from '../../../images/map_style/planned_vector_style.jpg';
import recordingsImage  from '../../../images/map_style/recordings_vector_style.jpg';
import completedImage   from '../../../images/map_style/completed_vector_style.jpg';
import proBadge         from '../../../images/PRO-PLUS_BADGE.svg';
import emitter from "../../../utils/bus";
import { RevenueCatWrapper } from '../../../utils/RevenueCatWrapper';
import { overlayLineTypeForSource } from '../../../utils/overlayLineStyles';

export default defineComponent({
  name: 'TrailOptions',

  emits: ['customise-overlay-line'],

  data() {
    return {
      proBadge,
      // Whether the current user is PRO+/PRO. Resolved async on mount; drives
      // the badge and the z15 unlock in addHeatmap (see the store toggle).
      heatmapIsPro: false,
    };
  },

  computed: {
    ...mapState('mapDataOverlays', [
      /* presentational */
      'trailOptions',
      /* overlay flags – now owned by the store */
      'officialHikesActive',
      'cellCoverageActive',
      'slopeAngleActive',
      'landAccessActive',
      'activeWeatherLayer',
      'cyclingRoutesActive',
      'heatmapActive'
    ]),
    ...mapGetters('mapDataOverlays', ['isSourceActive']),
  },

  watch: {
    /* ─────────── store actions ─────────── */
    officialHikesActive: function (newVal: boolean) {
      console.log("HiiKER trails active: ", newVal);
    },
    cellCoverageActive: function (newVal: boolean) {
      console.log("Cell coverage active: ", newVal);
    },
    slopeAngleActive: function (newVal: boolean) {
      console.log("Slope angle active: ", newVal);
    },
    activeWeatherLayer: function (newVal: any) {
      console.log("Active weather layer: ", newVal);
    }
  },

  methods: {
    /* ─────────── store actions ─────────── */
    ...mapActions('mapDataOverlays', [
      'toggleTrail',
      'toggleOfficialHikesOverlay',
      'toggleCellCoverageOverlay',
      'toggleSlopeOverlay',
      'toggleLandAccessOverlay',
      'toggleCyclingRoutesOverlay',
      'toggleWeatherOverlay',
      'toggleHeatmapOverlay',
      'initOverlayListeners',
      'initActiveSources',
      'destroyOverlayListeners'
    ]),

    /* ─────────── purely UI helpers ─────────── */
    // Only the line-drawing overlays get a line-style gear.
    overlayLineTypeForSource,

    getTrailImage(source: string) {
      switch (source) {
        case 'get_user_recordings':       return recordingsImage;
        case 'get_user_planned_trails':   return plannedImage;
        case 'get_user_completed_hikes': return completedImage;
        default:                          return plannedImage;
      }
    },

    makeDraggable(el: HTMLElement) {
      /* unchanged – provides swipe-scroll for the card lists */
      let isDown = false, startX = 0, scrollLeft = 0, moved = false;
      el.addEventListener('dragstart', e => e.preventDefault());
      el.addEventListener('mousedown',  e => { isDown = true; moved = false; el.classList.add('dragging');
        startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft; });
      el.addEventListener('mousemove',  e => { if (!isDown) return;
        const x = e.pageX - el.offsetLeft;
        if (Math.abs(x - startX) > 5) moved = true;
        el.scrollLeft = scrollLeft - (x - startX) * 1.5; });
      ['mouseup','mouseleave'].forEach(evt => el.addEventListener(evt, () => { isDown = false; el.classList.remove('dragging'); }));
      el.addEventListener('click', e => { if (moved) e.stopImmediatePropagation(); }, true);
    }
  },

  mounted() {
    this.initOverlayListeners();     // subscribe to bus + restore persisted overlays
    RevenueCatWrapper.isProOrProPlus().then(v => { this.heatmapIsPro = v; }).catch(() => {});
    nextTick(() => {
      [this.$refs.overlayScroll, this.$refs.weatherScroll, this.$refs.trailsScroll]
        .forEach((el: any) => el && this.makeDraggable(el));
    });
  },

  beforeUnmount() {
    this.destroyOverlayListeners();  // unsubscribe + clean map layers
  }
});
</script>

<style scoped>
/* ───── (identical presentation styles – no logic here) ───── */
.mapstyle-list{display:flex;overflow-x:auto;max-width:100%;padding-bottom:1em;}
.mapstyle-list::-webkit-scrollbar{display:none}
.mapstyle-list>.position-relative{flex:0 0 auto;}
.mapstyle-card{position:relative;width:120px;background:#fff;border:2px solid #434343;border-radius:6px;cursor:pointer;margin-top:1em;margin-right:1em;transition:border-color .3s ease;overflow:hidden}
.mapstyle-card-active{border-color:#fddf00}
.mapstyle-card img{width:100%}
.mapstyle-card .hiking-text{position:absolute;left:0;bottom:0;width:100%;background:rgba(0,0,0,.7);color:#fff}
.mapstyle-card img.mapstyle-pro-badge{position:absolute;top:4px;right:4px;width:auto;height:22px;z-index:2;filter:drop-shadow(0 1px 2px rgba(0,0,0,.5))}
/* Line-style gear, top-right of the card. Stops the click from also toggling
   the overlay (see @click.stop in the template). */
.mapstyle-line-style-btn{position:absolute;top:4px;right:4px;z-index:3;display:flex;align-items:center;justify-content:center;width:24px;height:24px;padding:0;border:none;border-radius:50%;background:rgba(0,0,0,.6);color:#fff;cursor:pointer;transition:background .15s}
.mapstyle-line-style-btn:hover{background:rgba(0,0,0,.85)}
.mapstyle-line-style-btn .material-icons{font-size:15px;line-height:1}
.mapstyle-list > .position-relative:first-child {
  margin-left: 1.5em;
}
@media(max-width:475px){.mapstyle-card{width:108px;margin-right:.7em}}

.la-overlay-thumb {
  width: 100%;
  aspect-ratio: 4/3;
  background: linear-gradient(135deg, #4CAF50 0%, #2196F3 25%, #FF9800 50%, #AB47BC 75%, #FF5722 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.la-overlay-thumb .material-icons {
  font-size: 36px;
  color: rgba(255,255,255,0.9);
  text-shadow: 0 1px 4px rgba(0,0,0,0.3);
}
</style>
